import { Filter } from "@/@types/index"
import { FilterResponse } from "../filters/models/FiltersResponse";

export function mapFilter(filter: FilterResponse): Filter {

  return {
    id: filter.id,
    title: filter.title,
    slug: filter.slug,
  }
}